<div class="roundSelectWrapper" [class]="color" [ngClass]="{active: active}">
    <div class="label">{{label}}</div>
    <div class="arrow">
        <img *ngIf="color=='blue'" src="assets/button-arrow.png" alt="">
        <img *ngIf="color=='white'" src="assets/button-arrow-white.png" alt="">
    </div>
</div>
 